import * as styled from './styles/close-button';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

const CLOSE_GLYPH = '×';

export const CloseButton = ({ className, ...rest }: Props) => (
  <styled.Button
    type="button"
    aria-label="Close"
    className={className}
    {...rest}
  >
    {CLOSE_GLYPH}
  </styled.Button>
);
